var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getProperty(obj) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    return (obj &&
        props.reduce(function (result, prop) {
            return result === null || result === undefined ? undefined : result[prop];
        }, obj));
}
function getPropertyFromPromisedObject(promise) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    return promise.then(function (obj) { return getProperty.apply(void 0, __spreadArray([obj], props)); });
}

var tenantSiteInfos = [
    {
        key: "derbund",
        name: "der Bund",
        domain: "derbund",
        feedId: 1,
        lang: "de",
        fbAppId: "160395880675799",
        twitterHandle: "@derbund"
    },
    {
        key: "tagesanzeiger",
        name: "Tages-Anzeiger",
        domain: "tagesanzeiger",
        feedId: 2,
        lang: "de",
        fbAppId: "147124108642216",
        twitterHandle: "@tagesanzeiger"
    },
    {
        key: "bernerzeitung",
        name: "Berner Zeitung",
        domain: "bernerzeitung",
        feedId: 3,
        lang: "de",
        fbAppId: "151632851557044",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "bazonline",
        name: "Basler Zeitung",
        domain: "bazonline",
        feedId: 5,
        lang: "de",
        fbAppId: "185771024788811",
        twitterHandle: "@bazonline"
    },
    {
        key: "berneroberlaender",
        name: "Berner Oberländer",
        domain: "berneroberlaender",
        feedId: 8,
        lang: "de",
        fbAppId: "209848109731135",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "thunertagblatt",
        name: "Thuner Tagblatt",
        domain: "thunertagblatt",
        feedId: 9,
        lang: "de",
        fbAppId: "428779510948903",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "langenthalertagblatt",
        name: "Langenthaler Tagblatt",
        domain: "langenthalertagblatt",
        feedId: 10,
        lang: "de",
        fbAppId: "2223961417826140",
        twitterHandle: "@BernerZeitung"
    },
    {
        key: "zsz",
        name: "Zürichsee-Zeitung",
        domain: "zsz",
        feedId: 11,
        lang: "de",
        fbAppId: "1538332599783320",
        twitterHandle: "@ZSZonline"
    },
    {
        key: "landbote",
        name: "Der Landbote",
        domain: "landbote",
        feedId: 12,
        lang: "de",
        fbAppId: "738531732909881",
        twitterHandle: "@landbote"
    },
    {
        key: "zuonline",
        name: "Zürcher Unterländer",
        domain: "zuonline",
        feedId: 13,
        lang: "de",
        fbAppId: "900877159943131",
        twitterHandle: "@ZUnterland"
    },
    {
        key: "tdg",
        name: "Tribune de Genève",
        domain: "tdg",
        feedId: 14,
        lang: "fr",
        fbAppId: "222318267841285",
        twitterHandle: "@tdgch"
    },
    {
        key: "24heures",
        name: "24 heures",
        domain: "24heures",
        feedId: 15,
        lang: "fr",
        fbAppId: "251285271592561",
        twitterHandle: "@24heuresch"
    },
    {
        key: "bilan",
        name: "Bilan",
        domain: "bilan",
        feedId: 17,
        lang: "fr",
        fbAppId: "389372458174754",
        twitterHandle: "@bilanmagazine"
    }
];

var defaultSiteInformation = {
    key: 'tagesanzeiger',
    abbr: 'ta',
    name: 'Tages-Anzeiger',
    domain: 'tagesanzeiger',
    feedId: 2,
    lang: 'de',
    paywallServiceId: 'tagesanzeiger',
    fbAppId: '147124108642216',
    twitterHandle: '@tagesanzeiger'
};
var siteInformationPromise = new Map();
function getSiteInformation(domainname) {
    if (siteInformationPromise.has(domainname)) {
        return siteInformationPromise.get(domainname);
    }
    var foundSiteInfo = tenantSiteInfos.find(function (tenant) { return tenant.domain === domainname; });
    var promise = Promise.resolve(foundSiteInfo || defaultSiteInformation);
    siteInformationPromise.set(domainname, promise);
    return promise;
}
function getLanguage(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'lang');
}
function getFeedId(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'feedId');
}
function getNiceName(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'name');
}
function getFacebookAppId(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'fbAppId');
}
function getTwitterHandle(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'twitterHandle');
}

var HTTPError = (function (_super) {
    __extends(HTTPError, _super);
    function HTTPError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'HTTPError';
        return _this;
    }
    return HTTPError;
}(Error));

function handleRequest() {
    return function (request) {
        if (request.ok)
            return request.json();
        throw new HTTPError(request.status + ": " + request.statusText);
    };
}

var MissingInfoError = (function (_super) {
    __extends(MissingInfoError, _super);
    function MissingInfoError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'MissingInfoError';
        return _this;
    }
    return MissingInfoError;
}(Error));

var apiEndpoint$1 = function (tenantId, articleId) {
    return "https://feed-prod.unitycms.io/" + tenantId + "/content/" + articleId;
};
var handleData$2 = function (articleId) { return function (data) {
    if (data === undefined || data === null) {
        throw new MissingInfoError('No data could be downloaded with article ID ' + articleId);
    }
    return data;
}; };
var articleDataPromises = new Map();
function getArticleInformation(tenantId, articleId) {
    if (articleDataPromises.has(articleId)) {
        return articleDataPromises.get(articleId);
    }
    var promise = fetch(apiEndpoint$1(tenantId, articleId))
        .then(handleRequest())
        .then(handleData$2(articleId));
    articleDataPromises.set(articleId, promise);
    return promise;
}
function getPublishingDate(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'published');
    });
}
function getUpdatedDate(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'updated');
    });
}
function getTitle(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'title');
    });
}
function getTitleHeader(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'titleHeader');
    });
}
function getLead(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'lead');
    });
}
function getDocType(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'paywall', 'docType');
    });
}
function isPremium(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'settings', 'premium');
    });
}
function getFullCategoryPath(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath');
    });
}
function getCategory(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath').then(function (path) { return path === null || path === void 0 ? void 0 : path.split('/')[0]; });
    });
}
function getSubCategory(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath').then(function (path) {
            var splitPath = path === null || path === void 0 ? void 0 : path.split('/');
            return splitPath && splitPath[1] ? splitPath[1] : path;
        });
    });
}
function getAuthors(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'authors').then(function (authorList) {
            var _a;
            return (_a = authorList === null || authorList === void 0 ? void 0 : authorList.map(function (authorObject) { return authorObject.name; })) !== null && _a !== void 0 ? _a : [];
        });
    });
}
function getCommentCounts(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'clientData', 'community', 'comments').then(function (commentCount) { return (commentCount ? parseInt(commentCount, 10) : 0); });
    });
}
function getTeaserImgSrc(domain, articleId, teaserSize) {
    if (teaserSize === void 0) { teaserSize = '800px'; }
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'image', 'variants', teaserSize, 'src');
    });
}
function getUrl(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'url').then(function (url) {
            if (!url) {
                return undefined;
            }
            if (/^https?:/.test(url)) {
                return url;
            }
            return "https://www." + domain + ".ch" + url;
        });
    });
}

function catchError$2(functionName, subclass, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return function (reason) {
        if (reason instanceof subclass) {
            console.warn("[" + functionName + "] " + reason.name + ": " + reason.message + ". Using default values instead.");
            return defaultValue;
        }
        throw reason;
    };
}

var defaultSharingEndpoint = function (domainName, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.subdomain, subdomain = _a === void 0 ? 'www' : _a, _b = opts.version, version = _b === void 0 ? 'v1' : _b;
    return "https://" + subdomain + "." + domainName + ".ch/disco-api/" + version + "/sharing";
};
var countsEndpoint = function (domainName, articleId, opts) { return defaultSharingEndpoint(domainName, opts) + "/" + articleId; };
var shareSignalEndpoint = function (domainName, opts) {
    return "" + defaultSharingEndpoint(domainName, opts);
};

var defaultShareCounts = {
    facebook: 0,
    twitter: 0,
    whatsapp: 0,
    email: 0,
    native: 0,
    linkedin: 0,
    total: 0
};
var defaultOptions$1 = {
    subdomain: 'www',
    version: 'v1'
};
function handleData$1(articleId) {
    return function (data) {
        return data.counts;
    };
}
function catchError$1(subclass) {
    return catchError$2('getSharingCounts', subclass, defaultShareCounts);
}
var shareCountPromiseCache = new Map();
function getSharingCounts(domainName, articleId) {
    if (shareCountPromiseCache.has(articleId)) {
        return shareCountPromiseCache.get(articleId);
    }
    var promise = fetch(countsEndpoint(domainName, articleId, defaultOptions$1))
        .then(handleRequest())
        .then(handleData$1())
        .catch(function (reason) {
        handleData$1()({
            counts: defaultShareCounts,
            articleId: articleId.toString()
        });
        throw reason;
    })
        .catch(catchError$1(HTTPError))
        .catch(catchError$1(Error));
    shareCountPromiseCache.set(articleId, promise);
    return promise;
}
function getTotalShareCount(domainName, articleId) {
    return getPropertyFromPromisedObject(getSharingCounts(domainName, articleId), 'total');
}

var defaultOptions = {
    subdomain: 'www',
    version: 'v1'
};
function postShareSignal(domainName, articleId, shareType) {
    return fetch(shareSignalEndpoint(domainName, defaultOptions), {
        body: JSON.stringify({ articleId: articleId, sharingType: shareType }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    })
        .then(handleRequest())
        .catch(function (reason) {
        console.warn("[postShareSignal]: share signal could not be delivered, due to\n        " + reason.name + ": " + reason.message + ".\n        While this might skew the statistics, worse things have happened.\n        ");
    });
}

var apiEndpoint = 'https://interaktiv.tagesanzeiger.ch/static/config/gtm-id.json';
function handleData(domainName) {
    return function (ids) {
        var id = ids[domainName];
        if (!id) {
            throw new MissingInfoError("No data available for domain " + domainName);
        }
        return id;
    };
}
var catchError = function (subclass) {
    return catchError$2('getGtmId', subclass);
};
var gtmIdPromise;
function getGtmId(domainName) {
    if (gtmIdPromise) {
        return gtmIdPromise;
    }
    var promise = fetch(apiEndpoint)
        .then(handleRequest())
        .then(handleData(domainName))
        .catch(catchError(Error));
    gtmIdPromise = promise;
    return promise;
}

export { getArticleInformation, getAuthors, getCategory, getCommentCounts, getDocType, getFacebookAppId, getFeedId, getFullCategoryPath, getGtmId, getLanguage, getLead, getNiceName, getPublishingDate, getSharingCounts, getSiteInformation, getSubCategory, getTeaserImgSrc, getTitle, getTitleHeader, getTotalShareCount, getTwitterHandle, getUpdatedDate, getUrl, isPremium, postShareSignal };
//# sourceMappingURL=index.m.js.map
